package one.devsbox.www.ui.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.coroutines.CoroutineScope
import one.devsbox.commons.ads.ApiAds
import one.devsbox.www.tools.EFieldTextValue
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel

class LoginCtx private constructor(
    val vm: LoginVM,
    val nav: Navigation,
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): LoginCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(LoginVM::class)
            return remember {
                LoginCtx(vm, nav).apply {
                    vm.setup(this)
                }
            }
        }
    }

    class EditorAuth(
        val scope: CoroutineScope,
        val data: ApiAds.LoginData
    ) {
        val login = EFieldTextValue(
            property = data::login,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )
        val password = EFieldTextValue(
            property = data::pass,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )
    }

    class PasswordChangeData(
        var pass: String = "",
        var passRepeat: String = ""
    )

    class EditorPass(
        val scope: CoroutineScope,
        val data: PasswordChangeData = PasswordChangeData()
    ) {
        val password = EFieldTextValue(
            property = data::pass,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )
        val passwordRepeat = EFieldTextValue(
            property = data::passRepeat,
            condition = { it.trim().takeIf { it.isNotEmpty() && it == data.pass } }
        )
    }
}